import { getDefiSdk } from '@/utils/defiSdk'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MILLISECONDS } from '@vaultsfyi/common/constants'
import type { Address } from 'viem'

export const claimRewardsQueryKey = ['claimRewards'] as const

interface ClaimRewardsQueryParams {
  address: Address | undefined
  claimIds: string[]
}

const claimRewardsQueryOptions = ({ address, claimIds }: ClaimRewardsQueryParams) => {
  return queryOptions({
    queryKey: [...claimRewardsQueryKey, { address, claimIds }] as const,
    async queryFn({ queryKey }) {
      const { address, claimIds } = queryKey[1]

      if (!address) return null
      if (!claimIds || claimIds.length === 0) return null

      const defiSdk = getDefiSdk()

      return await defiSdk.getRewardsClaimActions({
        path: { userAddress: address },
        query: { claimIds },
      })
    },
    enabled: !!address && !!claimIds && claimIds.length > 0,
    retry: 1,
    staleTime: 1 * MINUTE_IN_MILLISECONDS,
    refetchOnWindowFocus: true,
  })
}

export const useClaimRewardsQuery = ({ address, claimIds }: ClaimRewardsQueryParams) => {
  const {
    data: claimActions,
    isFetching,
    error,
  } = useQuery({
    ...claimRewardsQueryOptions({ address, claimIds }),
  })
  return { claimActions, isFetching, error }
}

export type ClaimRewards = ReturnType<typeof useClaimRewardsQuery>['claimActions']
